export const REQUEST_DROPDOWN_LIST_FROM = "REQUEST_DROPDOWN_LIST_FROM"
export const REQUEST_LOADING = "REQUEST_LOADING"